import {getIsFdd, useHasAllowedRole, useLoggedInUser} from '@product-web/shell/user'
import {OverdraftAdoptionPrompts} from '@product-web-features/credit/overdraft-adoption-prompts'

import {AutoTopUpAdoptionPrompts} from './auto-top-up-adoption-prompts/auto-top-up-adoption-prompts'
import {usePromptsPersistedState} from './auto-top-up-adoption-prompts/auto-top-up-adoption-prompts-state'

import {featureFundsManagementBff} from '../bff-hooks'

const useAutoTopUpAdoptionPrompts = () => {
    const user = useLoggedInUser()
    const isFdd = getIsFdd(user)

    const isOwnerOrBookkeeper = useHasAllowedRole([
        'owner',
        'bookkeeper-extended',
        'bookkeeper-basic',
    ])

    return featureFundsManagementBff.adoption.getAutoTopUpAdoptionPrompts.useQuery(undefined, {
        enabled: isFdd && isOwnerOrBookkeeper,
        staleTime: Infinity,
    })
}

export const WalletFeatureAdoptionPrompts = () => {
    const {data} = useAutoTopUpAdoptionPrompts()
    const canBeActivated = Boolean(data?.canBeActivated)
    const hasLowBalance = Boolean(data?.hasLowBalance)
    const hasDeclinedTransactions = Boolean(data?.hasDeclinedTransactions)

    const {dismissedPrompts} = usePromptsPersistedState()
    const isAutoTopUpPromptsVisible = canBeActivated && !dismissedPrompts?.dismissedDate

    if (!isAutoTopUpPromptsVisible) {
        // The Auto Top-up (ATU) prompts have a priority over Overdraft
        // If we can't show ATU prompts, return Overdraft prompts with their own conditions inside
        return <OverdraftAdoptionPrompts />
    }

    return (
        <AutoTopUpAdoptionPrompts
            canBeActivated={canBeActivated}
            hasLowBalance={hasLowBalance}
            hasDeclinedTransactions={hasDeclinedTransactions}
            declinedTransactionDetails={data?.declinedTransactionDetails}
        />
    )
}
